export class ModuleTypes {
  public static Preboarding = 1;
  public static Immigration = 2;
  public static Exit = 3;
}
export class Modules{
  public static CW="CW";
  public static EXIT = "EXT";
}

export class ValidationDocType{
    
  public static ImageDocument = 101;
  public static PDFDocument = 102;
 
}
export class AllowedDocumentFormat
{
public  static readonly allowedImageMineTypes =  [
  'image/jpeg'
 ,'image/png'
 
];
public  static readonly UAEallowedImageMineTypes =  [
  'image/jpeg',
  'image/jpg' 
  
 
];
public  static readonly allowedDocumentMineTypes =  [
  'application/pdf'
];
}

export class PhotoVerificationStatus
{

  public static readonly   SKIP_ALL = "SKIP_ALL";
  public static readonly   STRICT_VALIDATION_CHECK = "STRICT_VALIDATION_CHECK";
}

  export interface DocumentValidationMessage {
  errorMessage: string;
  errorType: string;
}

export class ErrorTypes{
    
  public static AUTO_APPROVAL_FAILED = 8001;
  public static EMAIL_Exception = 2002;


  public static IMM_PRFOILE_ALREARY_EXITS =9001
  public static   GENERAL_EXCEPTION = 9002;
  public static   IMM_SUCCESS = 9003;
 
}
